import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import GenderGateModal from "@/components/GenderGateModal";

/* Proactive prompt: any signed-in member without a gender sees the gate once per visit (right after sign-up,
   or on the next visit for existing members). Skipped on the Tournaments page, which runs its own hard gate. */
export default function GenderPrompt() {
  const { user, realUser } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!user || user.gender || realUser !== user) return;
    if (pathname.startsWith("/tournaments") || pathname.startsWith("/auth")) return;
    if (sessionStorage.getItem("pb_gender_prompted")) return;
    setOpen(true);
  }, [user, realUser, pathname]);
  if (!open) return null;
  const close = () => { sessionStorage.setItem("pb_gender_prompted", "1"); setOpen(false); };
  return <GenderGateModal open onDone={close} onCancel={close} reason="Welcome! Tournament events are built as Men's, Women's and Mixed brackets, so we need your gender on file before you can join or sign up." />;
}
